console.log('ORIGIN ACTUAL:', window.location.origin);

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('webform_reclamaciones');
  const btnSubmit = document.getElementById('webform_reclamaciones_submit_button');
  const loader = document.getElementById('webform_reclamaciones_sending_data');

  const tiendaSelect = document.getElementById('fieldLDR3');
  const razonSocialInput = document.getElementById('fieldLDR1');
  const rucInput = document.getElementById('fieldLDR2');
  const direccionInput = document.getElementById('fieldLDR4');
  const fechaInput = document.getElementById('fieldLDR31');

  if (!form || !btnSubmit) return;

  const tiendasData = {
    "1": {
      razon_social: "TELEBRANDS S.A.C",
      ruc: "20611185325",
      direccion: "AV. PASEO DE LA REPÚBLICA 3147 OF 301 - SAN ISIDRO - LIMA - LIMA",
    }
  };

  function setLoading(isLoading) {
    btnSubmit.disabled = isLoading;
    if (loader) {
      loader.style.display = isLoading ? 'block' : 'none';
    }
  }

  function completarDatosProveedor() {
    if (!tiendaSelect) return;

    const tiendaId = tiendaSelect.value;
    const data = tiendasData[tiendaId];

    if (data) {
      if (razonSocialInput) razonSocialInput.value = data.razon_social || '';
      if (rucInput) rucInput.value = data.ruc || '';
      if (direccionInput) direccionInput.value = data.direccion || '';
    } else {
      if (razonSocialInput) razonSocialInput.value = '';
      if (rucInput) rucInput.value = '';
      if (direccionInput) direccionInput.value = '';
    }
  }

function completarFecha() {
  if (!fechaInput) return;

  const hoy = new Date();
  const dd = String(hoy.getDate()).padStart(2, '0');
  const mm = String(hoy.getMonth() + 1).padStart(2, '0');
  const yyyy = hoy.getFullYear();

  fechaInput.value = `${dd}/${mm}/${yyyy}`;
}

  function clearErrors() {
    form.querySelectorAll('.validation-advice').forEach(function (el) {
      el.textContent = '';
      el.style.display = 'none';
    });

    form.querySelectorAll('.lr-input, .lr-select, .lr-textarea').forEach(function (el) {
      el.classList.remove('lr-input-error');
    });
  }

  function showErrorByElement(element, message) {
    if (!element) return;

    element.classList.add('lr-input-error');

    let errorBox = null;

    const field = element.closest('.lr-field');
    if (field) {
      errorBox = field.querySelector('.validation-advice');
    }

    if (!errorBox) {
      const checkboxGroup = element.closest('.lr-checkbox-group');
      if (checkboxGroup) {
        errorBox = checkboxGroup.querySelector('.validation-advice');
      }
    }

    if (errorBox) {
      errorBox.textContent = message;
      errorBox.style.display = 'block';
    }
  }

  function showRecaptchaError(message) {
    const box = document.getElementById('advice-recaptcha');
    if (!box) return;
    box.textContent = message;
    box.style.display = 'block';
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function validateFront() {
    clearErrors();

    let isValid = true;

    const requiredFields = form.querySelectorAll('.required-entry');

    requiredFields.forEach(function (field) {
      const type = (field.type || '').toLowerCase();

      if (type === 'checkbox') {
        if (!field.checked) {
          showErrorByElement(field, 'Este campo es requerido.');
          isValid = false;
        }
        return;
      }

      if (field.tagName === 'SELECT' && field.value.trim() === '') {
        showErrorByElement(field, 'Este campo es requerido.');
        isValid = false;
        return;
      }

      if (field.value.trim() === '') {
        showErrorByElement(field, 'Este campo es requerido.');
        isValid = false;
      }
    });

    const emailFields = form.querySelectorAll('.validate-email');
    emailFields.forEach(function (field) {
      const value = field.value.trim();
      if (value !== '' && !isValidEmail(value)) {
        showErrorByElement(field, 'Ingrese un email válido.');
        isValid = false;
      }
    });

    if (typeof grecaptcha !== 'undefined') {
      const recaptchaResponse = grecaptcha.getResponse();
      if (!recaptchaResponse) {
        showRecaptchaError('Completá el reCAPTCHA.');
        isValid = false;
      }
    }

    return isValid;
  }

  function applyServerErrors(errors) {
    if (!errors) return;

    Object.keys(errors).forEach(function (key) {
      const message = errors[key];

      if (key === 'recaptcha') {
        showRecaptchaError(message);
        return;
      }

      if (key === 'termsandcond') {
        const terms = form.querySelector('[name="termsandcond"]');
        showErrorByElement(terms, message);
        return;
      }

      const field = form.querySelector(`[name="${CSS.escape(key)}"]`);
      if (field) {
        showErrorByElement(field, message);
      }
    });
  }

  async function enviarFormulario() {
    if (!validateFront()) return;

    setLoading(true);

    try {
      const formData = new FormData(form);

      if (typeof grecaptcha !== 'undefined') {
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
      }

      const response = await fetch('https://libro-de-reclamaciones.bacteriumplus.com/guardar_reclamo.php', {
        method: 'POST',
        body: formData
      });

      const res = await response.json();

      if (res.ok) {
        window.location.href = res.redirect_url;
        return;
      }

      applyServerErrors(res.errors || null);
      alert(res.message || 'Revisá los campos marcados.');

      setLoading(false);

      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.reset();
      }
    } catch (error) {
      alert('Error de conexión.');
      setLoading(false);

      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.reset();
      }
    }
  }

 if (tiendaSelect) {
  tiendaSelect.addEventListener('change', function () {
    completarDatosProveedor();

    if (tiendaSelect.value.trim() !== '') {
      completarFecha();
    } else if (fechaInput) {
      fechaInput.value = '';
    }
  });

  completarDatosProveedor();
}

  btnSubmit.addEventListener('click', function (e) {
    e.preventDefault();
    enviarFormulario();
  });
});